export default "/images/ico-h-favorite.svg?e3c4db4afc643536fcf89ef12d6b581e";